import { ref, onMounted, getCurrentInstance } from "vue";
import { LD_FLAG_IDEA_MDP_450 } from "@components/constants/launchDarklyFlagKeys";

/** Resolves idea-MDP-450 (inline readiness chip on org-object headers). Off until the flag resolves true. */
export function useReadinessChipFlag() {
  const { proxy } = getCurrentInstance() || {};
  const enabled = ref(false);

  onMounted(async () => {
    try {
      enabled.value = (await proxy?.$getFlag?.(LD_FLAG_IDEA_MDP_450, false)) === true;
    } catch {
      enabled.value = false;
    }
  });

  return enabled;
}
